import GlobalMenu from 'components/GlobalMenu/GlobalMenu'
import ROUTE from 'constant/route'
import { Suspense } from 'react'
import { Switch, Route } from 'react-router-dom'
import SplashScreenPage from 'pages/SplashPage'
import PermissionRoute from 'router/PermissionRoute'

import { useAppSelector } from 'store/useStoreHook'
import { ClientType } from 'models'
import LazyRetry from 'components/LazyRetry/LazyRetry'

const LoginPage = LazyRetry(() => import('pages/LoginPage/LoginPage'))
const ForgetPage = LazyRetry(() => import('pages/ForgetPasswordPage'))
const RegisterDevicePage = LazyRetry(
    () => import('pages/RegisterDevicePage/RegisterDevicePage'),
)
const NotFoundPage = LazyRetry(() => import('pages/NotFoundPage'))
const RequestResetPasswordPage = LazyRetry(
    () => import('pages/ResetPasswordPage/RequestResetPasswordPage'),
)
const CustomerFacingDisplayPage = LazyRetry(
    () => import('pages/CustomerFacingDisplayPage/CustomerFacingDisplayPage'),
)
const ResetPasswordPage = LazyRetry(
    () => import('pages/ResetPasswordPage/ResetPassword'),
)
const LogoutPage = LazyRetry(() => import('pages/LogoutPage/LogoutPage'))
const PosTerminalLayout = LazyRetry(
    () => import('router/layouts/PosTerminalLayout'),
)
const OrderQueueLayout = LazyRetry(
    () => import('router/layouts/OrderQueueLayout'),
)
function MainRouter() {
    const currentClient = useAppSelector((state) => state.client.currentClient)

    return (
        <Suspense fallback={<SplashScreenPage />}>
            <GlobalMenu />
            <Switch>
                <Route
                    exact
                    path={ROUTE.RESET_PASSWORD}
                    component={ResetPasswordPage}
                />
                <Route
                    path={ROUTE.SELECT_DEVICE}
                    component={RegisterDevicePage}
                />
                <Route
                    path={ROUTE.CUSTOMER_FACING_DISPLAY}
                    component={CustomerFacingDisplayPage}
                />
                <Route exact path={ROUTE.FORGET} component={ForgetPage} />
                <Route exact path={ROUTE.LOGIN} component={LoginPage} />
                <Route exact path={ROUTE.LOGOUT} component={LogoutPage} />

                <Route
                    exact
                    path={ROUTE.REQUEST_RESET_PASSWORD}
                    component={RequestResetPasswordPage}
                />
                <PermissionRoute
                    path={ROUTE.NOT_FOUND}
                    component={NotFoundPage}
                />
                {(currentClient?.type === ClientType.PosTerminalWithCash ||
                    currentClient?.type ===
                        ClientType.PosTerminalWithOutCash) && (
                    <PosTerminalLayout />
                )}
                {currentClient?.type === ClientType.OrderQuesTerminal && (
                    <OrderQueueLayout />
                )}
            </Switch>
        </Suspense>
    )
}

export default MainRouter
